var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaseMaterial = function SvgCaseMaterial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M.161 0h44v44h-44z",
    "data-name": "Rectangle 25177"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3701",
    transform: "translate(-34 -1759)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#ebebeb",
    "data-name": "Ellipse 685",
    transform: "translate(34 1759)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "translate(46.839 1772)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#0e2240",
    "data-name": "Group 9470",
    transform: "translate(-923.758 -2287.061)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2.459,
    d: "m945.919 2288.327-9.786 2.413-7.545 6.685-3.573 9.424 1.215 10 5.725 8.3 8.925 4.673h10.083l8.925-4.673 5.725-8.3 1.215-10-3.573-9.424-7.545-6.685Z",
    "data-name": "Path 6013"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.844,
    cy: 8.844,
    r: 8.844,
    strokeWidth: 1.23,
    "data-name": "Ellipse 4721",
    transform: "translate(937.075 2300.233)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.761,
    cy: 17.761,
    r: 17.761,
    strokeWidth: 1.23,
    "data-name": "Ellipse 4722",
    transform: "translate(928.16 2291.318)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.919,
    cy: 4.919,
    r: 4.919,
    strokeWidth: 2.459,
    "data-name": "Ellipse 4723",
    transform: "translate(941 2304.158)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.23,
    d: "m945.919 2300.221-.015-8.878",
    "data-name": "Line 3202"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.23,
    d: "m941.765 2301.261-4.188-7.914",
    "data-name": "Line 3203"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.23,
    d: "m938.592 2304.139-7.447-4.995",
    "data-name": "Line 3204"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.23,
    d: "m937.132 2308.056-9.043-.848",
    "data-name": "Line 3205"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.23,
    d: "m937.658 2312.264-8.305 3.273",
    "data-name": "Line 3206"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.23,
    d: "m940.065 2315.705-5.863 6.736",
    "data-name": "Line 3207"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.23,
    d: "m943.846 2317.675-2.211 8.667",
    "data-name": "Line 3208"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.23,
    d: "m948.088 2317.64 2.086 8.649",
    "data-name": "Line 3209"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.23,
    d: "m951.878 2315.624 5.725 6.766",
    "data-name": "Line 3210"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.23,
    d: "m954.221 2312.099 8.182 3.384",
    "data-name": "Line 3211"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.23,
    d: "m954.706 2308.076 8.854-1.026",
    "data-name": "Line 3212"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.23,
    d: "m953.329 2304.227 7.388-5.032",
    "data-name": "Line 3213"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.23,
    d: "m950.151 2301.295 4.132-7.845",
    "data-name": "Line 3214"
  }))))));
};
export { SvgCaseMaterial as ReactComponent };
export default "/_next/static/images/caseMaterial.svg";